import Slider from "../../components/Slider/Slider";
import styles from "./SliderModule.module.scss";
function SliderModule() {
  return (
    <div className={styles.SliderModule}>
       <Slider/>
    </div>
  );
}

export default SliderModule;
